'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;
// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter2 = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter2);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _lodash = require('lodash');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _lib = require('helpers/lib');

var _support = require('helpers/support');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _config = require('../../../config');

var _config2 = _interopRequireDefault(_config);

var _NewFilterMobile = require('./NewFilterMobile');

var _NewFilterMobile2 = _interopRequireDefault(_NewFilterMobile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PARAMS_ALLOWED = {
  subs: 'subcategory',
  province: 'province',
  district: 'district',
  sort: 'sort'
};

var WAIT_INTERVAL = 100;
var seoInfos = {
  'cham-soc-da-massage': {
    title: 'Địa điểm chăm sóc da và massage tốt nhất',
    description: 'Địa điểm chăm sóc da và massage tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm trị mụn, trị sẹo thâm, nám, giúp trẻ hóa da, làm sạch và thanh tẩy. Địa điểm triệt lông, tắm trắng. Địa điểm massage mặt, massage body. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'lam-toc-mong': {
    title: 'Địa điểm làm tóc và làm móng tốt nhất',
    description: 'Địa điểm làm tóc, làm móng tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm làm tóc, làm móng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'tham-my-vien': {
    title: 'Địa điểm thẩm mỹ viện tốt nhất',
    description: 'Địa điểm thẩm mỹ viện tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm thẩm mỹ viện làm mắt, mũi, mặt, ngực, bụng, miệng và giảm cân. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'phong-kham': {
    title: 'Địa điểm phòng khám tốt nhất',
    description: 'Địa điểm phòng khám tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm phòng khám da, phòng khám răng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'the-duc-the-thao': {
    title: 'Địa điểm tập thể dục thể thao gym tốt nhất',
    description: 'Địa điểm tập thể dục thể thao tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm tập thể dục thể thao, tập yoga, tập gym, học nhảy dance, địa điểm hồ bơi. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'xam-hinh': {
    title: 'Địa điểm xăm hình tốt nhất',
    description: 'Địa điểm xăm hình tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm xăm hình theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'salon-mi-va-mong': {
    title: 'Địa điểm salon mi và móng tốt nhất',
    description: 'Địa điểm salon mi và móng tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm salon mi và móng theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'spa-cham-da': {
    title: 'Địa điểm spa chăm da tốt nhất',
    description: 'Địa điểm spa chăm da tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm spa chăm da theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'massage-va-goi-dau': {
    title: 'Địa điểm massage và gội đầu tốt nhất',
    description: 'Địa điểm massage và gội đầu tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm massage và gội đầu theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'tham-my-va-nha-khoa': {
    title: 'Địa điểm thẩm mỹ và nha khoa tốt nhất',
    description: 'Địa điểm thẩm mỹ và nha khoa tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm thẩm mỹ và nha khoa theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'salon-toc-va-make-up': {
    title: 'Địa điểm salon tóc và make-up tốt nhất',
    description: 'Địa điểm salon tóc và make-up tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm salon tóc và make-up theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  }
};
var NewCategory = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _shops.isProminentLoaded)(getState())) {
      promises.push(dispatch((0, _shops.getProminent)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    shops: state.filter.data,
    total: state.filter.total,
    query: state.filter.query,
    categories: state.setup.categories,
    suggests: state.setup.suggests,
    categoriesFilter: state.setup.categoriesFilter,
    districts: state.address.districts,
    province: state.address.province,
    provinces: state.address.provinces,
    addressFilter: state.address.addressFilter,
    subCatFilter: state.setup.subCatFilter,
    loaded: state.filter.loaded,
    locationUser: state.user.coords,
    loading: state.filter.loading,
    flagSearch: state.filter.flagSearch,
    sort: state.filter.sort,
    coords: state.user.coords
  };
}, (0, _extends3.default)({}, shopActions, filterActions, addressActions, setupActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NewCategory, _Component);

  function NewCategory(props) {
    (0, _classCallCheck3.default)(this, NewCategory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewCategory.__proto__ || (0, _getPrototypeOf2.default)(NewCategory)).call(this, props));

    _this.state = {
      page: 1,
      filter: [],
      filterActive: {},
      collapse: (0, _lib.initCollapse)(_this.props.categories),
      addressFilter: _this.props.addressFilter,
      subCatFilter: _this.props.subCatFilter,
      categoriesFilter: _this.props.categoriesFilter,
      query: _this.props.query,
      page_size: 12,
      showFilter: false,
      showSubFilter: false,
      currentFilterActive: '01',
      cat: 'cham-soc-da-massage',
      focus: false
    };

    _this.lazyLoad = true;
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.openFilter = _this.openFilter.bind(_this);
    _this.closeFilter = _this.closeFilter.bind(_this);
    _this.searchShop = _this.searchShop.bind(_this);
    _this.initFilter = _this.initFilter.bind(_this);
    _this.shopLazyLoad = _this.shopLazyLoad.bind(_this);
    _this.checkSortNearby = _this.checkSortNearby.bind(_this);
    _this.setFilterActive = _this.setFilterActive.bind(_this);
    _this.getResult = _this.getResult.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }
  /*
     filter được dùng để render dữ liệu. filter là mảng vì cần thứ tự ưu tiên trước sau khi render.
     filterActive hổ trợ render đồng thời cũng là dữ liệu để parse ra dữ liệu submit và url. filterActive là object vì cần index nhanh không cần thứ tự.
     filterActiveTemp loại active hổ trợ cho render. Đang suy nghỉ có cần thiết đưa vào hay không.
     filter = [{ key: 'category', type: '', data: [{label: 'chăm sóc da', value: '01'}, ...] }, { key: 'subcategory', type: '', data: [...] } , ..., {...}]
     filterActive = { category: ['01'], subcategory: ['011', '012'], province: [...],...}
  */


  (0, _createClass3.default)(NewCategory, [{
    key: 'initFilter',
    value: function initFilter(category) {
      var _props = this.props,
          query = _props.location.query,
          categories = _props.categories,
          districts = _props.districts,
          province = _props.province,
          sort = _props.sort,
          textQuery = _props.query,
          catCode = _props.route.cat;
      // Xử lý dữ liệu lần đầu tiên, còn phải code cứng chổ này.

      var filterActive = {};
      filterActive.query = [textQuery];
      var filter = [_support.syncData.cats(category || categories), _support.syncData.dists(districts), _support.syncData.subs(catCode)];
      if (catCode) {
        filterActive.category = [catCode];
      } else {
        filterActive.category = [];
      }
      for (var key in PARAMS_ALLOWED) {
        if (PARAMS_ALLOWED.hasOwnProperty(key)) {
          var _key = PARAMS_ALLOWED[key];
          if (query.hasOwnProperty(key)) {
            var _value = query[key].split(',');
            filterActive[_key] = [].concat((0, _toConsumableArray3.default)(_value));
          } else {
            // Những trường dữ liệu không có trên URL. Thì vào đây. Những trường này có thể chạy ngầm bên dưới ở nhiều trang ví dụ province được dùng cả trang chủ và trang search.
            switch (_key) {
              case 'province':
                filterActive.province = [province];
                break;
              case 'sort':
                filterActive.sort = [sort];
                break;
              default:
                filterActive[_key] = [];
            }
          }
        }
      }
      this.setState({ filter: filter, filterActive: filterActive });
      this.searchShop(filterActive);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.timer = null;
      this.initFilter();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var _state = this.state,
          filterActive = _state.filterActive,
          page = _state.page,
          pageSize = _state.pageSize;

      var reloadThreshold = 1.5 * window.innerHeight;
      var scrollTriggerHeight = document.body.scrollHeight - window.innerHeight - window.scrollY;
      if (scrollTriggerHeight <= reloadThreshold && this.lazyLoad) {
        this.lazyLoad = false;
        var newFilterActive = (0, _extends3.default)({}, filterActive, {
          page: ['' + (page + 1)],
          pageSize: ['' + pageSize]
        });
        this.shopLazyLoad(newFilterActive);
        this.setState(function (prevState) {
          return {
            page: prevState.page + 1
          };
        });
      }
    }
  }, {
    key: 'shopLazyLoad',
    value: function shopLazyLoad(filterActive) {
      var _props2 = this.props,
          changeFilter = _props2.changeFilter,
          lazyLoad = _props2.lazyLoad;

      var active = filterActive ? (0, _extends3.default)({}, filterActive) : {};
      var filter = (0, _extends3.default)({}, this.state.filterActive, active);
      changeFilter(filter);
      filter = this.checkSortNearby(filter);
      lazyLoad(filter);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var flag = false;
      if (this.props.flagSearch !== nextProps.flagSearch) {
        flag = true;
      }
      if (!(0, _lodash.isEqual)(nextProps.districts, this.props.districts)) {
        var dists = _support.syncData.dists(nextProps.districts);
        var filter = this.setFilter('district', dists);
        var filterActive = (0, _extends3.default)({}, this.state.filterActive);
        filterActive.district = [];
        this.setState({ filter: filter, filterActive: filterActive });
      }
      if (nextProps.categories !== this.props.categories) {
        this.initFilter(nextProps.categories);
      }
      if (nextProps.province !== this.props.province) {
        this.setFilterActive('province', [nextProps.province]);
      }
      if (nextProps.sort !== this.props.sort) {
        this.setFilterActive('sort', [nextProps.sort]);
      }
      if (nextProps && nextProps.location && this.props.location) {
        if (nextProps.location.search !== this.props.location.search || nextProps.location.pathname !== this.props.location.pathname) {
          // ::this.initCategory(nextProps.location);
        }
      }
      if (!(0, _lodash.isEqual)(this.props.shops, nextProps.shops)) {
        this.lazyLoad = true;
      }
      if (flag) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getResult, WAIT_INTERVAL);
      }
    }
  }, {
    key: 'setFilter',
    value: function setFilter(key, data) {
      // Input key, data (object filter)
      // Set giá trị mới cho filter, vì nó là mảng nên buộc phải for, mảng dùng render theo thứ tự.
      var filter = [].concat((0, _toConsumableArray3.default)(this.state.filter));
      for (var i = 0, len = filter.length; i < len; i++) {
        if (filter[i].key === key) {
          filter[i] = data;
        }
      }
      return filter;
    }
  }, {
    key: 'setFilterActive',
    value: function setFilterActive(key, arr) {
      var filterActive = (0, _extends3.default)({}, this.state.filterActive);
      filterActive[key] = arr;
      this.setState({ filterActive: filterActive });
    }
  }, {
    key: 'checkSortNearby',
    value: function checkSortNearby(filterActive) {
      var filter = (0, _extends3.default)({}, filterActive);
      var coords = this.props.coords;

      if (coords && coords.latitude && filter.sort && filter.sort.length && filter.sort[0] === 'nearby') {
        filter.lat = [coords.latitude];
        filter.lng = [coords.longitude];
      }
      return filter;
    }
  }, {
    key: 'searchShop',
    value: function searchShop(filterActive) {
      var _props3 = this.props,
          changeFilter = _props3.changeFilter,
          getShopSearch = _props3.getShopSearch;

      var active = filterActive ? (0, _extends3.default)({}, filterActive) : {};
      var filter = (0, _extends3.default)({}, this.state.filterActive, active);
      changeFilter(filter);
      filter = this.checkSortNearby(filter);
      getShopSearch(filter);
      var catCode = filter.category && filter.category.length ? filter.category[0] : '';
      this.props.history.push((0, _extends3.default)({}, this.props.location, {
        pathname: _support.syncData.getPathByCat(catCode),
        query: (0, _support.parseQuery)(filter)
      }));
    }
  }, {
    key: 'province',
    value: function province() {
      var _props4 = this.props,
          province = _props4.province,
          provinces = _props4.provinces;

      if (provinces && provinces.length) {
        var result = provinces.filter(function (v) {
          return v.code === province;
        });
        return result.length ? result[0].name : '';
      }
      return '';
    }
  }, {
    key: 'onFilterClose',
    value: function onFilterClose() {
      this.setState({ showFilter: false });
    }
  }, {
    key: 'getResult',
    value: function getResult(filter) {
      var _filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter, this.props.sort, this.props.locationUser);
      if (filter) {
        _filter = (0, _lib.processQuery)(this.state.query, this.props.province, filter.areasActive, filter.categoriesFilter, filter.subCatFilter, this.props.sort, this.props.locationUser);
      }
      this.props.getSearchResult(_filter);
    }
  }, {
    key: 'handleSuggest',
    value: function handleSuggest(sort) {
      this.props.changeSortType(sort);
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter() {
      this.setState({
        showFilter: !this.state.showFilter
      });
    }
  }, {
    key: 'openFilter',
    value: function openFilter() {
      this.props.openFilter();
      this.setState({
        showFilter: true
      });
    }
  }, {
    key: 'closeFilter',
    value: function closeFilter() {
      this.props.closeFilter();
      this.setState({
        showFilter: false
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(key, item) {
      var filterActive = (0, _extends3.default)({}, this.state.filterActive);
      switch (key) {
        case 'category':
          filterActive[key] = [];
          filterActive.subcategory = [];
          break;
        default:
          if (filterActive[key].indexOf(item.value) !== -1) {
            (0, _lodash.pull)(filterActive[key], item.value);
          }
      }
      this.setState({ filterActive: filterActive });
      this.searchShop(filterActive);
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focus: true });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focus: false });
      document.activeElement.blur();
    }
  }, {
    key: 'getClass',
    value: function getClass(cls) {
      if (this.state.focus === true) {
        return cls;
      }
      return '';
    }
  }, {
    key: 'iconCat',
    value: function iconCat(code) {
      var styles = require('./DiscoverMobile.scss');
      switch (code) {
        case '01':
          return _react2.default.createElement('img', { className: styles.spa, src: _Images2.default.cats.spa });
        case '02':
          return _react2.default.createElement('img', { className: styles.hair, src: _Images2.default.cats.hair });
        case '03':
          return _react2.default.createElement('img', { className: styles.cosmetic, src: _Images2.default.cats.cosmetic });
        case '04':
          return _react2.default.createElement('img', { className: styles.clinic, src: _Images2.default.cats.clinic });
        case '05':
          return _react2.default.createElement('img', { className: styles.fitness, src: _Images2.default.cats.fitness });
        case '06':
          return _react2.default.createElement('img', { className: styles.tatoo, src: _Images2.default.cats.tatoo });
        case '07':
          return _react2.default.createElement('img', { className: styles.homeService, src: _Images2.default.cats.homeService });
        case 'M1':
          return _react2.default.createElement('img', { className: styles.spa, src: _Images2.default.cats.salonMiMong });
        case 'M2':
          return _react2.default.createElement('img', { className: styles.hair, src: _Images2.default.cats.spaChamDa });
        case 'M3':
          return _react2.default.createElement('img', { className: styles.cosmetic, src: _Images2.default.cats.massageGoiDau });
        case 'M4':
          return _react2.default.createElement('img', { className: styles.clinic, src: _Images2.default.cats.thamMyNhaKhoa });
        case 'M5':
          return _react2.default.createElement('img', { className: styles.fitness, src: _Images2.default.cats.salonTocMakeUp });
        case 'M6':
          return _react2.default.createElement('img', { className: styles.fitness, src: _Images2.default.cats.hoiThao });
        case 'M7':
          return _react2.default.createElement('img', { className: styles.fitness, src: _Images2.default.cats.khoaHoc });
        default:
          break;
      }
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(filter, filterActive) {
      this.setState({ filter: filter, filterActive: filterActive });
      this.closeFilter();
      this.searchShop(filterActive);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          shops = _props5.shops,
          suggests = _props5.suggests,
          sort = _props5.sort,
          loading = _props5.loading;
      var _state2 = this.state,
          showFilter = _state2.showFilter,
          filter = _state2.filter,
          filterActive = _state2.filterActive;

      var styles = require('./DiscoverMobile.scss');
      var labelCats = (0, _support.getListActive)('category', filter, filterActive);
      var labelSubCat = (0, _support.getListActive)('subcategory', filter, filterActive);
      var labelAddress = (0, _support.getListActive)('district', filter, filterActive);
      var suggestsList = [];
      if (suggests && suggests.length > 0) {
        suggests.map(function (v, i) {
          return suggestsList.push(_react2.default.createElement(
            'div',
            {
              className: styles.label + ' ' + (sort !== undefined && sort === v.code ? styles.active : ''),
              key: 'suggest_' + i,
              onClick: function onClick() {
                return _this2.handleSuggest(v.code);
              }
            },
            v.label
          ));
        });
      }
      var meta = [];
      var seoInfo = seoInfos && seoInfos[this.state.cat] ? seoInfos[this.state.cat] : null;
      var title = seoInfo && seoInfo.title ? seoInfo.title : '';
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      var url = global.location ? _config2.default.siteUrl + global.location.pathname : '';
      if (url) {
        meta.push({ property: 'og:url', content: url });
      }
      if (seoInfo && seoInfo.image) {
        meta.push({ property: 'og:image', content: seoInfo.image });
      }
      if (seoInfo && seoInfo.description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: seoInfo.description
        });
      }
      console.log('filter', this.state.filter);
      return _react2.default.createElement(
        'div',
        {
          className: styles.discoverMobile + ' ' + this.getClass(styles.focus)
        },
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
        _react2.default.createElement('div', {
          className: styles.bgCover,
          onClick: this.onBlur,
          onTouchMove: this.onBlur
        }),
        _react2.default.createElement(
          'div',
          { className: styles.filterBar },
          _react2.default.createElement(
            'div',
            {
              className: styles.filterBtn + (showFilter ? ' ' + styles.btnFilterActive : ''),
              onClick: this.openFilter
            },
            _react2.default.createElement(
              'div',
              { className: styles.filterText },
              'B\u1ED9 L\u1ECDc'
            ),
            _react2.default.createElement(_reactBootstrap.Glyphicon, {
              className: styles.arrowDown,
              glyph: showFilter ? 'menu-up' : 'menu-down'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.slider },
            _react2.default.createElement(
              'div',
              { className: styles.sliderInside },
              _react2.default.createElement(
                'div',
                { className: styles.lType },
                labelCats && labelCats.length > 0 && labelCats.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lType_' + index },
                    _this2.iconCat(item.value),
                    _react2.default.createElement(
                      'span',
                      { className: styles.text },
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this2.handleRemove('category', item);
                      }
                    })
                  );
                }),
                labelSubCat && labelSubCat.length > 0 && labelSubCat.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lType_' + index },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this2.handleRemove('subcategory', item);
                      }
                    })
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.lAddress },
                labelAddress && labelAddress.length > 0 && labelAddress.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lAddress_' + index },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this2.handleRemove('district', item);
                      }
                    })
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(_NewFilterMobile2.default, {
          showFilter: this.state.showFilter,
          provinceName: this.province(),
          closeFilter: this.closeFilter,
          onSubmit: this.onSubmit,
          filter: this.state.filter,
          filterActive: this.state.filterActive
        }),
        _react2.default.createElement(
          'div',
          { className: styles.listCard },
          (!shops || shops.length === 0) && !loading && _react2.default.createElement(
            'div',
            { className: styles.noHistory },
            _react2.default.createElement(
              'div',
              { className: styles.textNoHistory },
              'Kh\xF4ng c\xF3 c\u1EEDa h\xE0ng n\xE0o ph\xF9 h\u1EE3p.'
            )
          ),
          shops && shops.map(function (shop, key) {
            return _react2.default.createElement(_components.SmallCardMobile, { shop: shop, key: 'card_' + key });
          })
        )
      );
    }
  }]);
  return NewCategory;
}(_react.Component), _class2.propTypes = {
  history: _react.PropTypes.object,
  shops: _react.PropTypes.array,
  total: _react.PropTypes.number,
  categories: _react.PropTypes.array,
  suggests: _react.PropTypes.array,
  districts: _react.PropTypes.array,
  addressFilter: _react.PropTypes.array,
  subCatFilter: _react.PropTypes.object,
  changeQuery: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  changeSortType: _react.PropTypes.func.isRequired,
  getSearchResult: _react.PropTypes.func.isRequired,
  getShopSearch: _react.PropTypes.func.isRequired,
  changeFilter: _react.PropTypes.func.isRequired,
  openFilter: _react.PropTypes.func.isRequired,
  closeFilter: _react.PropTypes.func.isRequired,
  lazyLoad: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.string,
  provinces: _react.PropTypes.array,
  province: _react.PropTypes.string,
  location: _react.PropTypes.object,
  categoriesFilter: _react.PropTypes.object,
  loaded: _react.PropTypes.bool,
  locationUser: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  flagSearch: _react.PropTypes.bool,
  changeFlag: _react.PropTypes.func,
  changeAddress: _react.PropTypes.func,
  sort: _react.PropTypes.string,
  params: _react.PropTypes.object,
  route: _react.PropTypes.object,
  coords: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = NewCategory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/NewCategory.js
// module id = 1544
// module chunks = 0